import React from 'react';

import type {Item} from '../../../generated/types';
import {EntitySeo} from '../../../lib/seo';
import {buildUrl} from '../../../lib/routes';
import {itemDescription, itemKind} from './item-seo-text';

export const ItemSeo: React.FC<{
	item: Item;
	/** адрес страницы, если это не адрес самой записи: старая редакция открыта как вариант новой */
	path?: string;
}> = ({item, path}) => (
	<EntitySeo
		entity={item}
		section="items"
		kind={itemKind(item)}
		description={itemDescription(item)}
		path={path ?? buildUrl('item', {id: item.id})}
		og={{kind: 'item'}}
		keywords={[itemKind(item)]}
	/>
);
